import { render, staticRenderFns } from "./VendorUpload.vue?vue&type=template&id=38d923ec&scoped=true&"
import script from "./VendorUpload.vue?vue&type=script&lang=js&"
export * from "./VendorUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d923ec",
  null
  
)

export default component.exports